export default __webpack_public_path__ + "65dbfcc741115eb58bc6060265211fc5.webp";